<template>
  <div>
    <v-col class="pt-5">
      <v-row class="justify-center">
        <v-col cols="12" sm="6" md="4">
          <timerpayment
            v-if="data.trx_midtrans_expired_datetime"
            :date="data.trx_midtrans_expired_datetime"
          ></timerpayment>
          <div class="mt-5">
            <v-card elevation="0" class="pt-1 pb-2 rounded-0 psr-border">
              <v-col clas="text-body-2">
                <div class="pb-3 d-flex justify-space-between" v-if="data.trx_payment_text">
                  <div
                    class="font-weight-bold text-body-2 my-auto text-uppercase"
                  >{{data.trx_payment_text.payment_text}}</div>
                  <div>
                    <v-img width="50" :src="data.trx_payment_text.payment_image"></v-img>
                  </div>
                </div>
                <v-divider></v-divider>
              </v-col>
              <v-col
                class="pt-2 pb-0 text-body-2"
                v-if="data.trx_payment_method != 'payment_store'"
              >
                <div class="d-flex justify-space-between">
                  <div>
                    <div class="text-body-2 grey--text text--darken-1">
                      <span v-if="data.trx_payment_method == 'va'">No. Virtual Account</span>
                      <span v-else>Nomor Rekening</span>
                    </div>
                    <div class="text-body-1 font-weight-bold">{{ data.trx_midtrans_payment_code }}</div>
                    <input type="hidden" :value="data.trx_midtrans_payment_code" id="inputCopy" />
                  </div>
                  <div class="my-auto">
                    <v-btn
                      text
                      color="primary"
                      class="px-0 text-capitalize font-weight-bold"
                      @click="copyme"
                    >
                      <div class="text-copy">Salin</div>
                    </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col
                class="pt-2 pb-0 text-body-2"
                v-if="data.trx_payment_method == 'payment_store'"
              >
                <div class="d-flex justify-space-between">
                  <div>
                    <div class="text-body-2 grey--text text--darken-1">Penjual</div>
                    <div class="text-body-1 font-weight-bold">{{data.store.user_name}}</div>
                  </div>
                </div>
              </v-col>
              <v-col
                class="pt-2 pb-0 text-body-2"
                v-if="data.trx_payment_method == 'payment_store'"
              >
                <div class="d-flex justify-space-between">
                  <div>
                    <div class="text-body-2 grey--text text--darken-1">Alamat</div>
                    <div class="text-body-1 font-weight-bold">{{addressTextStore(data.store)}}</div>
                  </div>
                </div>
              </v-col>
              <v-col class="pb-0 text-body-2">
                <div>
                  <div>
                    <div class="text-body-2 grey--text text--darken-1">Pembeli</div>
                    <div class="text-body-1 font-weight-bold">{{ data.trx_buyer_user_name }}</div>
                  </div>
                </div>
              </v-col>
              <v-col class="text-body-2">
                <div class="d-flex justify-space-between">
                  <div>
                    <div class="text-body-2 grey--text text--darken-1">Total Pembayaran</div>
                    <div
                      class="text-body-1 red--text font-weight-bold"
                    >Rp {{ data.trx_price_grand_total | toNumber }}</div>
                  </div>
                </div>
              </v-col>
            </v-card>
          </div>
          <div class="mt-5">
            <v-row class="justify-center">
              <v-col md="8" class="py-0">
                <div>
                  <v-btn
                    outlined
                    height="45"
                    block
                    color="#272727"
                    class="rounded-lg"
                    @click="downloadPDF(data.trx_pdf_url)"
                    v-if="data.trx_pdf_url"
                  >
                    <div class="font-weight-bold text-body-2">Cara Pembayaran</div>
                  </v-btn>
                </div>
                <div class="mt-3 text-center">
                  <router-link :to="{name: 'transaction'}" class="text-deco">
                    <v-btn depressed height="45" block color="#272727" class="rounded-lg">
                      <div class="font-weight-bold text-body-2 white--text">Lihat Transaksi</div>
                    </v-btn>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import timerpayment from "@/components/Timer";
export default {
  components: {
    timerpayment
  },
  props: {
    data: Object
  },
  methods: {
    addressTextStore(value) {
      var data = [];
      if (value) {
        if (value.store_address) data.push(value.store_address);
        if (value.store_subdistrict_name)
          data.push(value.store_subdistrict_name);
        if (value.store_city_name) data.push(value.store_city_name);
        if (value.store_province_name) data.push(value.store_province_name);
      }
      return data.join(", ");
    },
    downloadPDF(pdf) {
      window.open(pdf);
    },
    copyme() {
      var copyText = document.getElementById("inputCopy");
      copyText.setAttribute("type", "text");
      copyText.select();
      try {
        document.execCommand("copy");
        setTimeout(function() {
          setTimeout(function() {
            document.querySelector(".text-copy").innerHTML = "Salin";
          }, 1000);
          document.querySelector(".text-copy").innerHTML = "Tersalin";
        }, 300);
      } catch (err) {
        alert("Oops, tidak dapat menyalin");
      }
      copyText.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Pembayaran");
    if (this.data.trx_status != "created" && this.data.trx_status != "pending") {
      this.$router.push({ name: "transaction" });
    }
  }
};
</script>